import type { Actions } from '@ngrx/effects';
import { ofType } from '@ngrx/effects';
import { merge, filter } from 'rxjs';

import { AsyncJobActions } from '@core/async-job-data';
import { AsyncJobType } from '@core/async-job-types';
import { FullCandidateActions } from '@core/candidate-data';
import { PlacementActions } from '@core/placements-data';

export const placementChanges$ = (actions$: Actions) =>
  merge(
    actions$.pipe(
      ofType(
        PlacementActions.disqualifySuccess,
        PlacementActions.requalifySuccess,
        PlacementActions.removeOnePessimisticSuccess,
        FullCandidateActions.createOnePessimisticSuccess,
        FullCandidateActions.updateOnePessimisticSuccess,
      ),
    ),
    actions$.pipe(
      ofType(AsyncJobActions.finish),
      filter(({ payload }) =>
        [AsyncJobType.BulkCandidatesDeleteCandidates].includes(payload.job.type),
      ),
    ),
  );
